export const AWS_S3_BUCKET = "waffy-files";
export const AWS_S3_BASE_URL =
  "https://waffy-files.s3.eu-west-1.amazonaws.com/";
export const CONTRACT_PATH = "images/contracts/${contractId}/$fileName";
export const PROFILE_PATH = "images/users/${userId}/$fileName";
export const REACT_APP_AWS_ACCESS_KEY_ID =
  process.env.REACT_APP_AWS_ACCESS_KEY_ID;
